import React, { useRef, useEffect, useCallback, useState } from "react";


const companies = [
  {
    id: 1,
    name: "Expedia",
    logo: "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/expedia.svg",
    fallback: "https://placehold.co/200x80?text=Expedia",
  },
  {
    id: 2,
    name: "Booking",
    logo: "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/booking.svg",
    fallback: "https://placehold.co/200x80?text=Booking",
  },
  {
    id: 3,
    name: "Hotelbeds",
    logo: "https://placehold.co/200x80?text=Hotelbeds",
    fallback: "https://placehold.co/200x80?text=Hotelbeds",
  },
  {
    id: 4,
    name: "Amadeus US",
    logo: "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/amadeus.svg",
    fallback: "https://placehold.co/200x80?text=Amadeus+US",
  },
  {
    id: 5,
    name: "Amadeus Tunisia",
    logo: "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/amadeus.svg",
    fallback: "https://placehold.co/200x80?text=Amadeus+Tunisia",
  },
  {
    id: 6,
    name: "Marriott",
    logo: "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/marriott.svg",
    fallback: "https://placehold.co/200x80?text=Marriott",
  },
  {
    id: 7,
    name: "Accor",
    logo: "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/accor.svg",
    fallback: "https://placehold.co/200x80?text=Accor",
  },
  {
    id: 8,
    name: "Tulip Inn",
    logo: "https://placehold.co/200x80?text=Tulip+Inn",
    fallback: "https://placehold.co/200x80?text=Tulip+Inn",
  },
  {
    id: 9,
    name: "Hilton",
    logo: "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/hilton.svg",
    fallback: "https://placehold.co/200x80?text=Hilton",
  },
  {
    id: 10,
    name: "Sunhotel",
    logo: "https://placehold.co/200x80?text=Sunhotel",
    fallback: "https://placehold.co/200x80?text=Sunhotel",
  },
  {
    id: 11,
    name: "Dida",
    logo: "https://placehold.co/200x80?text=Dida",
    fallback: "https://placehold.co/200x80?text=Dida",
  },
  {
    id: 12,
    name: "DOTW",
    logo: "https://placehold.co/200x80?text=DOTW",
    fallback: "https://placehold.co/200x80?text=DOTW",
  },
  {
    id: 13,
    name: "Abreu Tunisia",
    logo: "https://placehold.co/200x80?text=Abreu+Tunisia",
    fallback: "https://placehold.co/200x80?text=Abreu+Tunisia",
  },
  {
    id: 14,
    name: "Bedsen",
    logo: "https://placehold.co/200x80?text=Bedsen",
    fallback: "https://placehold.co/200x80?text=Bedsen",
  },
];

// Duplicate items for infinite scrolling
const extendedCompanies = [
  ...companies,
  ...companies,
  ...companies,
];

const Partners = ({ t }) => {
  const scrollContainerRef = useRef(null);

  const [hovered, setHovered] = useState(false);

  // Card width + gap
  const getCardWidth = useCallback(() => {
    return 204; // 180 width + 24 gap
  }, []);

  // Auto scroll
  const autoScroll = useCallback(() => {
    const container = scrollContainerRef.current;

    if (!container || hovered) return;

    container.scrollLeft += 1;

    const maxScroll =
      container.scrollWidth - container.clientWidth;

    // Infinite loop reset
    if (container.scrollLeft >= maxScroll / 1.5) {
      container.scrollLeft =
        companies.length * getCardWidth();
    }
  }, [hovered, getCardWidth]);

  // Start auto-scroll
  useEffect(() => {
    const container = scrollContainerRef.current;

    if (!container) return;

    // Start from middle set
    container.scrollLeft =
      companies.length * getCardWidth();

    const interval = setInterval(autoScroll, 15);

    return () => clearInterval(interval);
  }, [autoScroll, getCardWidth]);

  return (
    <div className="container-xl pb-5">
      <div className="fs-1 text-center mb-5 mt-0">
        {t("partners_caption")}
      </div>

      <div
        className="horizontal-scroll-wrapper d-flex overflow-hidden mb-5 pb-5"
        ref={scrollContainerRef}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {extendedCompanies.map((company, index) => (
          <div
            key={`${company.id}-${index}`}
            className="carousel-card flex-shrink-0 d-flex align-items-center justify-content-center bg-white rounded-4 shadow-sm p-4"
          >
            <img
              src={company.logo}
              alt={company.name}
              className="img-fluid"
              loading="lazy"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = company.fallback;
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Partners;